import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorComponent } from './editor.component';
import { IonicModule } from '@ionic/angular';
import { TranslationModule } from '@app/app-translation.module';
import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [EditorComponent],
	exports: [EditorComponent],
	imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslationModule, QuillModule.forRoot()],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EditorComponentModule {}
